import { CwxBackend } from '@/types/cwxBackend';
import config from '../../service/project.config';
import axios from 'axios';

export default {
  async getSpaceDetails(spaceId: number): Promise<CwxBackend.ISpaceDetailsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getDetails?spaceId=${spaceId}`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },

  async getSpaceSettingsForIdea(ideaId: number): Promise<CwxBackend.ISpaceSettingsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getSpaceSettingsForIdea?ideaId=${ideaId}`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },

  async getMyItemsList(): Promise<CwxBackend.IMyItemsListDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getMyItemsList`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getSpaceType(spaceId: number): Promise<CwxBackend.SpaceType> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getSpaceType?spaceId=${spaceId}`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getSpaceHomePage(spaceId: number): Promise<CwxBackend.ISpaceHomeDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getSpaceHomePage?spaceId=${spaceId}`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
  async getSpaceSettings(spaceId: number): Promise<CwxBackend.ISpaceSettingsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/space/getSpaceSettings?spaceId=${spaceId}`;
    return axios.get(endpointUrl).then((response) => {
      return response.data;
    });
  },
};
